import type { Placement } from '@core/placements-types';
import type { Stage } from '@core/stages-types';

export function getNextStage(placement: Placement, stages: Stage[]): Stage | null {
  const currentStageId = placement.stage?.id;

  if (!currentStageId) {
    return null;
  }

  const currentStageIndex = stages.findIndex(stage => stage.id === currentStageId);

  if (currentStageIndex === -1) {
    return null;
  }

  const isCurrentStageLocked = stages[currentStageIndex].locked;

  if (isCurrentStageLocked) {
    return stages.find(stage => !stage.locked) ?? null;
  }

  return stages?.[currentStageIndex + 1] ?? null;
}
